/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { captionPositions } from '../../constants';
export const VOLUME_INDICATOR_TOP_START_POSITION = 3;
export const VOLUME_INDICATOR_BOTTOM_START_POSITION = 1;
export const VOLUME_INDICATOR_CONTROLS_SHOWN_OFFSET = 4;
const generateStyle = (_, props, state) => {
  const position = props.position,
    showControls = props.showControls;
  const showNotification = state.showNotification;
  const calculateOffset = () => {
    if (position === captionPositions.BOTTOM) {
      return showControls ? VOLUME_INDICATOR_CONTROLS_SHOWN_OFFSET + VOLUME_INDICATOR_BOTTOM_START_POSITION : VOLUME_INDICATOR_BOTTOM_START_POSITION;
    }
    return VOLUME_INDICATOR_TOP_START_POSITION;
  };
  return {
    container: {
      position: 'absolute',
      [position]: `${calculateOffset()}rem`,
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '0.5rem',
      background: 'rgba(0, 0, 0, 0.7)',
      padding: '0.5rem',
      borderRadius: '6px',
      color: '#F5F5F5',
      fontSize: '0.75rem',
      opacity: showNotification ? 1 : 0,
      transitionProperty: 'opacity',
      transitionDuration: '0.2s'
    }
  };
};
export default generateStyle;